import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import DraggableCart from './DraggableCart';
import Cart from './Cart';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContextNew';
import SignUpPromptModal from './SignUpPromptModal';

const GlobalCart = () => {
  const [showCart, setShowCart] = useState(false);
  const { totalItems } = useCart();
  const location = useLocation();
  const { isGuest } = useAuth();
  
  // Guest mode states
  const [showSignUpPrompt, setShowSignUpPrompt] = useState(false);
  const [restrictedFeature, setRestrictedFeature] = useState('');

  // Auth routes where cart should not be shown
  const authRoutes = ['/login', '/signup', '/forgot-password', '/guest'];
  const isAuthRoute = authRoutes.includes(location.pathname);
  
  // Pages that have their own cart implementation (currently none, GlobalCart is used everywhere)
  const pagesWithOwnCart = [];
  const hasOwnCart = pagesWithOwnCart.some(route => location.pathname.startsWith(route));

  // Guest mode handlers
  const handleGuestRestriction = (featureName) => {
    setRestrictedFeature(featureName);
    setShowSignUpPrompt(true);
  };

  // Listen for custom event to open cart - ALWAYS listen, even in guest mode
  useEffect(() => {
    const handleOpenCart = () => {
      if (isGuest) {
        handleGuestRestriction('checkout');
      } else {
        setShowCart(true);
      }
    };

    window.addEventListener('openCart', handleOpenCart);
    return () => window.removeEventListener('openCart', handleOpenCart);
  }, [isGuest]);

  // Don't show cart UI on auth routes
  if (isAuthRoute) {
    // Still render signup modal for guest mode cart clicks
    return (
      <SignUpPromptModal
        open={showSignUpPrompt}
        onClose={() => setShowSignUpPrompt(false)}
        featureName={restrictedFeature}
      />
    );
  }

  // Only show draggable cart button if there are items and not on pages with their own cart
  if (totalItems === 0 || hasOwnCart) {
    // Still render signup modal for guest mode
    return (
      <SignUpPromptModal
        open={showSignUpPrompt}
        onClose={() => setShowSignUpPrompt(false)}
        featureName={restrictedFeature}
      />
    );
  }

  const handleCartClick = () => {
    if (isGuest) {
      handleGuestRestriction('checkout');
    } else {
      // Only open cart if it's not already open
      if (!showCart) {
        setShowCart(true);
      }
    }
  };

  return (
    <>
      {/* Draggable Cart - Show for both authenticated and guest users */}
      {!isGuest && <DraggableCart onCartClick={handleCartClick} />}

      {/* Cart Dialog - Only for authenticated users */}
      {!isGuest && <Cart open={showCart} onClose={() => setShowCart(false)} />}

      {/* Sign Up Prompt Modal for Guest Users */}
      <SignUpPromptModal
        open={showSignUpPrompt}
        onClose={() => setShowSignUpPrompt(false)}
        featureName={restrictedFeature}
      />
    </>
  );
};

export default GlobalCart; 